import fetch from "../../../../utils/fetch";

const getInitialState = () => {
  return {
    isLoading: false,
    accountPreferences: null,
    memberPreferences: null,
    error: null,
  }
}

const state = getInitialState();

const getters = {
  isLoading(state) {
    return state.isLoading
  },
  accountPreferences(state) {
    return state.accountPreferences
  },
  memberPreferences(state) {
    return state.memberPreferences
  },
  error(state) {
    return state.error
  },
}

const actions = {
  getAccountPrefs({commit}) {
    commit(types.SET_NOTIFICATION_PREFERENCES_LOADING)
    return fetch('/users/' + localStorage.getItem('userId') + '/notification_preferences?exists[projectMember]=false')
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        commit(types.SET_USER_NOTIFICATION_PREFERENCES, data['hydra:member'])
        return data
      })
      .catch((error) => {
        commit(types.SET_NOTIFICATION_PREFERENCES_ERROR, error)
      })
  },

  getProjectMemberPrefs({commit}, data) {
    commit(types.SET_NOTIFICATION_PREFERENCES_LOADING)
    return fetch('/users/' + localStorage.getItem('userId') + '/notification_preferences?projectMember.id=' + data.memberId)
      .then((response) => {
        return response.json()
      })
      .then((data) => {
        commit(types.SET_PROJECTMEMBER_NOTIFICATION_PREFERENCES, data['hydra:member'])
        return data
      })
      .catch((error) => {
        commit(types.SET_NOTIFICATION_PREFERENCES_ERROR, error)
      })
  },

  updateAccountPref({commit, dispatch}, data) {
    commit(types.SET_NOTIFICATION_PREFERENCES_LOADING)
    return fetch('/notification_preference/' + data.id, {
      method: 'PATCH',
      body: JSON.stringify(data)
    }).then((response) => {
        return response.json()
      })
      .then((data) => {
        dispatch("getAccountPrefs", null, {root: false})
        return data
      })
      .catch((error) => {
        commit(types.SET_NOTIFICATION_PREFERENCES_ERROR, error)
      })
  },

  addUpdateMemberPref({commit, dispatch}, data) {
    commit(types.SET_NOTIFICATION_PREFERENCES_LOADING)
    let url = '/notification_preference'
    let method = 'POST'
    if (data['@id']) {
      url = url + '/' + data.id
      method = 'PATCH'
    }
    return fetch(url, {
      method: method,
      body: JSON.stringify(data)
    }).then((response) => {
      return response.json()
    })
      .then((data) => {
        dispatch("getProjectMemberPrefs", {memberId: data.projectMember['@id']}, {root: false})
        return data
      })
      .catch((error) => {
        commit(types.SET_NOTIFICATION_PREFERENCES_ERROR, error)
      })
  },
}

const types = {
  SET_NOTIFICATION_PREFERENCES_LOADING: 'SET_NOTIFICATION_PREFERENCES_LOADING',
  SET_USER_NOTIFICATION_PREFERENCES: 'SET_USER_NOTIFICATION_PREFERENCES',
  SET_PROJECTMEMBER_NOTIFICATION_PREFERENCES: 'SET_PROJECTMEMBER_NOTIFICATION_PREFERENCES',
  SET_NOTIFICATION_PREFERENCES_ERROR: 'SET_NOTIFICATION_PREFERENCES_ERROR',
  RESET: 'RESET',
}

const mutations = {

  [types.SET_NOTIFICATION_PREFERENCES_LOADING](state) {
    state.isLoading = true;
  },

  [types.SET_USER_NOTIFICATION_PREFERENCES](state, userPreferences) {
    state.accountPreferences = userPreferences;
    state.isLoading = false;
  },

  [types.SET_PROJECTMEMBER_NOTIFICATION_PREFERENCES](state, userProjectPreferences) {
    state.memberPreferences = userProjectPreferences;
    state.isLoading = false;
  },

  [types.SET_NOTIFICATION_PREFERENCES_ERROR](state, error) {
    state.isLoading = true;
    state.error = error;
  },

  [types.RESET](state) {
    Object.assign(state, getInitialState());
  },
}

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations,
}
